import { render } from "./InputBarPill.vue?vue&type=template&id=362007c4&scoped=true"
import script from "./InputBarPill.vue?vue&type=script&lang=js"
export * from "./InputBarPill.vue?vue&type=script&lang=js"

import "./InputBarPill.vue?vue&type=style&index=0&id=362007c4&lang=scss&scoped=true"
import "./InputBarPill.vue?vue&type=style&index=1&id=362007c4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362007c4"]])

export default __exports__